export default "__VITE_ASSET__CjKRnwgF__"